import { pulseliveSSO } from '@pulselive/keycloak-sdk-wrapper';

/**
 * CMS API request to check feature flag status
 *
 * @param {string} flag - name to check for
 * @returns {boolean} - flag status 
 */
const checkFeatureFlag = async (flag) => {
    const apiUrl = pulseliveSSO.config['api-url'];
    const headers = { ...pulseliveSSO.getAuthHeader() };

    try {
        const response = await fetch(`${apiUrl}/feature/available/${flag}`, { headers } );
        if (!response.ok) {
            throw new Error('Feature flag check failed');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching feature flag: ', error);
        return false;
    }
}


export { checkFeatureFlag }